//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data(){
    return{
      statucode:''
    }
  },
  beforeMount(){
    if(this.$router.history.current.path == "/commodityMesReply"){
      document.title = "审核页";
    }
    this.statucode = this.$router.history.current.query.status;
  }
}



// WEBPACK FOOTER //
// ./src/components/fleaMarketComponents/checkFailure.vue